/* global define, window, Tourist */

define('views/TourView',[
    'jquery',
    'underscore',
    'backbone',
    'tourist'
], function($, _, Backbone) {

    'use strict';

    var View = Backbone.View.extend({
        initialize: function() {

            // Bind All
            _.bindAll(this);

            this.$window = $(window);
        },
        overlaysTour: function() {
            console.log('coming soon');
        },
        drawTour: function() {

            if (this.tour) {
                this.tour.stop();
                this.tour = null;
                return;
            }

            var showAreas = $('.overlaysButton').is(':visible')
            var steps = [];
        
            steps.push({
                content: '<p>Before you begin your search for a new property please take a quick tour of this search tool.</p>',
                closeButton: true,
                highlightTarget: true,
                nextButton: true,
                target: $('.topSearchBarView'),
                my: 'top center',
                at: 'bottom center'
            });
            steps.push({
                content: '<p>Above the map are custom search filters to help you narrow your results.</p>',
                closeButton: true,
                highlightTarget: true,
                nextButton: true,
                target: $('.dropdown:first'),
                my: 'top left',
                at: 'bottom right'
            });
            if(showAreas){
                steps.push({
                    content: '<p>When clicking the Areas button, you can specify locations you are interested in.</p>',
                    closeButton: true,
                    highlightTarget: true,
                    nextButton: true,
                    target: $('.overlaysButton'),
                    my: 'top right',
                    at: 'bottom right'
                });
            }
            steps.push({
                content: '<p>The hand tool is used for dragging the map around.</p>',
                closeButton: true,
                highlightTarget: true,
                nextButton: true,
                target: $('.handButton'),
                my: 'right center',
                at: 'left center'
            });
            steps.push({
                content: '<p>You can draw custom search boundaries by selecting the rectangle, circle or polygon drawing tools.</p>',
                highlightTarget: true,
                nextButton: true,
                target: $('.drawingViewDrawControls'),
                my: 'right center',
                at: 'left center'
            })
            steps.push({
                content: '<p>Click here to clear the map of boundaries and listings.</p>',
                highlightTarget: true,
                nextButton: true,
                target: $('.cancelButton'),
                my: 'right center',
                at: 'left center'
            })
            steps.push({
                content: '<p>Click here to remove all listings.</p>',
                highlightTarget: true,
                nextButton: true,
                target: $('.markersoffButton'),
                my: 'right center',
                at: 'left center'
            });
            steps.push({
                content: '<p>Click here to watch this tour again.</p>',
                highlightTarget: true,
                nextButton: true,
                target: $('.tooltipButton'),
                my: 'right center',
                at: 'left center'
            })

            this.tour = new Tourist.Tour({
                steps: steps,
                tipClass: 'Bootstrap',
                tipOptions: {
                    showEffect: 'slidein'
                }
            });
            this.tour.start();
        }
    });

    return View;
});

